import React, { FC, useEffect, useRef, useState } from 'react';

// @ts-ignore
import Tab from '@r1-frontend/ui-react/components/tabs/tab';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { TABS } from '~/src/features/movix-new/FilmsBlock/data';

import * as ST from './styled';

interface IFilmSettings {
    resolution?: number,
    imageWidth: number,
    columnGap: number,
}

const FILMS_SETTINGS = {
    default: {
        imageWidth: 252,
        columnGap: 18,
    },
    tablet: {
        resolution: 1023,
        imageWidth: 132,
        columnGap: 12,
    },
    sDesktop: {
        resolution: 1365,
        imageWidth: 146,
        columnGap: 13,
    },
    desktop: {
        resolution: 1600,
        imageWidth: 195,
        columnGap: 14,
    },
};

const MAX_COUNT_IMAGES = 7;

const FilmsBlock: FC = () => {
    const [activeTab, setActiveTab] = useState(TABS[0].label);
    const [countImages, setCountImages] = useState(MAX_COUNT_IMAGES);
    const [imageWidth, setImageWidth] = useState(FILMS_SETTINGS.default.imageWidth);
    const [columnGap, setColumnGap] = useState(FILMS_SETTINGS.default.columnGap);
    const sliderRef = useRef();
    const imagesRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const onResize = () => {
            const width = window.innerWidth;

            if (width <= FILMS_SETTINGS.tablet.resolution) {
                changeCount(FILMS_SETTINGS.tablet);
            } else if (width <= FILMS_SETTINGS.sDesktop.resolution) {
                changeCount(FILMS_SETTINGS.sDesktop);
            } else if (width <= FILMS_SETTINGS.desktop.resolution) {
                changeCount(FILMS_SETTINGS.desktop);
            } else {
                changeCount(FILMS_SETTINGS.default);
            }
        };

        const changeCount = ({ imageWidth, columnGap }: IFilmSettings) => {
            const imagesWidth = imagesRef.current?.clientWidth;

            if (!imagesWidth) {
                return;
            }

            const count = Math.floor(imagesWidth / (imageWidth + columnGap));
            setCountImages(count > MAX_COUNT_IMAGES ? MAX_COUNT_IMAGES : count);
            setImageWidth(imageWidth);
            setColumnGap(columnGap);
        };
        onResize();

        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    const onSwipe = (slide: number) => {
        setActiveTab(TABS[slide].label);
    };

    const onSwitchTab = (label: string) => {
        setActiveTab(label);
        // @ts-ignore
        sliderRef.current?.swipeTo(TABS.findIndex(tab => tab.label === label));
    };

    return (
        <>
            <ST.STabs activeTab={activeTab} accentColor={COLORS.TextWhite} onSwitchTab={onSwitchTab}>
                {TABS.map(({ label }, i) => (
                    <Tab key={i} label={label} />
                ))}
            </ST.STabs>
            <ST.Carousel
                ref={sliderRef}
                showArrows={false}
                showDots={false}
                changeCallback={onSwipe}
            >
                {TABS.map(({ images }, containerKey) => (
                    <ST.ImagesContainer
                        key={containerKey}
                        ref={imagesRef}
                        count={countImages}
                        imageWidth={imageWidth}
                        columnGap={columnGap}
                        maxCount={images.length / 2}
                    >
                        {images.map((img, i) => (
                            <ST.Image key={i} src={img.src}>
                                {typeof img.age !== 'undefined' && <ST.Age>{img.age}+</ST.Age>}
                                {img.label && <ST.TextImage width={img.label.width} src={img.label.src} />}
                            </ST.Image>
                        ))}
                    </ST.ImagesContainer>
                ))}
            </ST.Carousel>
        </>
    );
};

export default FilmsBlock;
